import type { StyleRule } from '@archipro-design/aria';
import {
    boxClassName,
    buttonClassName,
    captionClassName,
    labelClassName,
    pxToRem,
    listClassName,
} from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';
import { hex2rgba } from '~/utils/colorHelper';

export const ContentContainer: StyleRule = () => ({
    minHeight: pxToRem(398),
    height: 'auto',
    marginBottom: pxToRem(87),
});

export const AboutTextContainer: StyleRule = () => ({
    display: 'flex',
    flexDirection: 'column',
    gap: pxToRem(100),
    paddingBottom: pxToRem(240),
});

export const AboutTextContent: StyleRule = ({ theme }) => ({
    paddingTop: pxToRem(0),
    [`& .${boxClassName}`]: {
        [`& div *`]: {
            color: theme.siteVariables.colors.charcoal[250],
            fontSize: pxToRem(16),
            lineHeight: '130%',
        },
        '& a': {
            textDecoration: 'underline',
            color: theme.siteVariables.colors.charcoal[250],
            '&:hover': {
                color: theme.siteVariables.colors.primitive.black,
            },
        },
    },
    [`& > .${buttonClassName}`]: {
        textTransform: 'none',
        padding: 0,

        [`& .${labelClassName}`]: {
            fontSize: pxToRem(16),
            lineHeight: '130%',
            letterSpacing: 0,
            textUnderlineOffset: pxToRem(2),
            textDecorationThickness: `${pxToRem(2)} !important`,
        },
        '&:hover': {
            background: 'transparent',
        },
    },
});

export const LinkContainer: StyleRule<{ visible: boolean }> = ({
    theme,
    visible,
}) => ({
    display: 'block',
    [`&.${listClassName}:first-child`]: {
        borderTop: 'none',
    },
    width: pxToRem(434),
    marginBottom: pxToRem(128),

    '& > [role=listitem]': {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 0,
        borderColor: hex2rgba(
            theme.siteVariables.colors.primitive.black,
            visible ? 0.5 : 1,
        ),
        '&:hover': {
            borderColor: hex2rgba(
                theme.siteVariables.colors.primitive.black,
                visible ? 1 : 0.5,
            ),
        },
        [`& > .${captionClassName}`]: {
            height: pxToRem(54),
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
            color: theme.siteVariables.colors.charcoal['000'],
            [`&  .${captionClassName}`]: {
                fontSize: pxToRem(20),
                letterSpacing: theme.siteVariables.letterSpacingSmall,
                opacity: visible ? 0.5 : 1,
            },
            [`& .${boxClassName} .${svgIconClassName}`]: {
                position: 'relative',
                bottom: pxToRem(1),
                height: pxToRem(30),
                width: pxToRem(30),
                opacity: 0,
                marginRight: pxToRem(8),
            },
            '&:hover': {
                color: theme.siteVariables.colors.charcoal['000'],
                [`&  .${captionClassName}`]: {
                    opacity: 1,
                },
                [`& .${boxClassName} .${svgIconClassName}`]: {
                    opacity: 1,
                    marginRight: 0,
                    transition:
                        'opacity 300ms ease-in-out, margin 200ms ease-in-out',
                },
            },
        },
    },
});
